import { render, staticRenderFns } from "./TheFollowerCardA.vue?vue&type=template&id=79e62264&"
import script from "./TheFollowerCardA.vue?vue&type=script&lang=js&"
export * from "./TheFollowerCardA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports